export const AEONIK = "Aeonik"
export const AEONIK_AIR = "Aeonik Air"
export const AEONIK_FONO = "Aeonik Fono"
export const AEONIK_FONO_AIR = "Aeonik Fono Air"
export const ROOBERT = "Roobert"
